import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ASK_AI, BASE_URL, QUICK_AI } from "../../../Constants/Config";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";

const initialState = {
  loading: false,
  data: [],
  error: false,
};

// Generate pending, fulfilled and rejected action types
export const fetchAIImplementationData = createAsyncThunk(
  "attributes/fetchAIImplementationData.",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(QUICK_AI, dataNew, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("data====>", response, response.data, response.status);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const attributesSlice = createSlice({
  name: "askAI",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAIImplementationData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAIImplementationData.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(fetchAIImplementationData.rejected, (state, action) => {
      state.loading = false;
      state.data = {};
      state.error = action.error.message;
    });
  },
});

export default attributesSlice.reducer;
